// src/padplanner/MapChrome.jsx
//
// What floats on a PadPlanner map, as PadPlannerMap's slots: a hint banner at
// the top, a readout card at the bottom left, and a bar along the bottom (the
// time strip). The zoom control is MapLibre's own (PadPlannerMap adds it).
// Presentational only; each page decides what goes in them.

/** "Click to place corners, right-click to finish." */
export function MapHint({ children }) {
  return (
    <p className="pointer-events-none rounded-md border border-bg-border bg-bg/85 px-3 py-1.5 text-[12px] text-fg-primary shadow"
      data-testid="pp-map-hint">
      {children}
    </p>
  );
}

/** Label / value rows: area, perimeter, cursor. Rows whose value is null are left out. */
export function MapReadout({ rows }) {
  const shown = rows.filter((r) => r.value !== null && r.value !== undefined && r.value !== "");
  if (shown.length === 0) return null;
  return (
    <dl className="grid grid-cols-[auto_auto] gap-x-3 gap-y-0.5 rounded-md border border-bg-border bg-bg/85 px-3 py-2 text-[12px] shadow"
      data-testid="pp-map-readout">
      {shown.map((r) => (
        <div key={r.label} className="contents">
          <dt className="op-label uppercase">{r.label}</dt>
          <dd className="op-mono text-fg-primary">{r.value}</dd>
        </div>
      ))}
    </dl>
  );
}
